/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsCostSortCriteria {
    getFixupPrototypeFunction() { return AIUnitEconomicsCostSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsCostSortCriteria>): AIUnitEconomicsCostSortCriteria {
        let obj = Object.assign(new AIUnitEconomicsCostSortCriteria(), model);
        AIUnitEconomicsCostSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsCostSortCriteria>): AIUnitEconomicsCostSortCriteria {
        if (!model) return null;
        return AIUnitEconomicsCostSortCriteria.newInstance(<AIUnitEconomicsCostSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsCostSortCriteria) {
        if (!obj) return;

        models.AIUnitEconomicsCostSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsCostSortCriteria): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsCostSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AIUnitEconomicsCostSortColumn;

    ascending: boolean;

}
